import axios from "axios";
import Decorater from "./decorater/Decorater";
import ErrorPointCreator from "./pointer/ErrorPointCreator";
import LintErrorPoints from "./pointer/LintErrorPoints";
import AIErrorPoints from "./pointer/AIErrorPoints";
import { normalizeSpaceForLint } from "../utils/helper";
/**
 *  ###spanタグ###
 * <span data-order="0" data-index="0" data-info_type="lint">~</span>
 * :data-info_type には指摘箇所の種類を指定する
 * :data-order には指摘タイプの中での順番を指定する
 * :data-index には指摘箇所の文中の中でのindexを指定する
 *
 * ###結果タグ###
 * <li data-rule_idx="0" data-rule_id="1文の長さは100文字以下とする。" data-rule_type="lint">
 * rule_idx :　その指摘タイプの中での順番
 *
 *
 * finalErrorAnalysis : {
 *  [指摘箇所のindex] : {
 *     [この指摘箇所のindexがどのタイプで指摘されれいるか] : [その指摘タイプの中での順番]
 * }
 *
 *
 * spanタグと結果の紐づけは上記のようになっている
 * spanタグをクリックすると、indexを取得してfinalErrorAnalysisから該当するindexの情報を取得し、
 * 指摘タイプの中での順番を取得する　取得したorderから結果をハイライトとして表示する
 *
 */
export default class ProofeadText {
    text;
    targetContent;
    pointOutRuleStatus;
    user;
    constructor(targetContent, inputText, user) {
        this.targetContent = targetContent;
        this.text = inputText;
        this.user = user;
        this.pointOutRuleStatus = {};
    }
    async execLint(rulePaths, ruleConfigs, clientId, ignoreRuleIds, signal) {
        // 装飾（Decorater）には入力エリアと同じNBSP入りのthis.textを使い、
        // 各APIへはNBSPを半角スペースへ戻したテキストを送る
        const lintText = normalizeSpaceForLint(this.text);
        /**
         *
         * 1. ~~~
         * 2. ~~~
         * 3. ~~~
         * こんなかんじで\nで区切られたテキストを行数をつけて連結する。
         * chatGPTに指摘箇所のindexを返してもらう際、行数をつけないと制度が落ちるため、行数をつけて送信する。
         */
        const textFotGpt = lintText.split('\n').map((text, index) => {
            return `${index + 1}. ${text}`;
        }).join('\n');
        //どれか一つでもエラーが発生した場合でも、他の処理を続行するためにPromise.allSettledを使用
        // TODO 安本 model 適正なバージョンを調査
        return await Promise.allSettled([
            axios.post(rulePaths.lintBaseUrl + '/textlint', {
                text: lintText,
                userid: this.user.id
            }, { signal: signal }),
            axios.post(rulePaths.lintBaseUrl + '/kuromojin', {
                text: lintText
            }, { signal: signal }),
            axios.post(rulePaths.getWordUrl, null, { signal: signal }),
            axios.post(rulePaths.lintBaseUrl + '/gpt', {
                text: textFotGpt,
                model: 'gpt-5.4-mini',
                clientId: clientId
            }, { signal: signal })
        ]).then(([textLintResponse, kuromojiResponse, wordResponse, gptResponse]) => {
            const textlintResults = textLintResponse.status === 'fulfilled' ? textLintResponse.value.data : [];
            const kuromojiResults = kuromojiResponse.status === 'fulfilled' ? kuromojiResponse.value.data : [];
            const registerWords = wordResponse.status === 'fulfilled' ? wordResponse.value.data.text : [];
            const gptResult = gptResponse.status === 'fulfilled' ? gptResponse.value.data : { errors: [] };
            console.log('textlintResults', textlintResults);
            //指摘箇所の情報を作る為のクラス
            const errorPointCreator = new ErrorPointCreator();
            const lintErrorPoints = errorPointCreator.createErrorPoint(new LintErrorPoints(textlintResults, rulePaths, ruleConfigs, ignoreRuleIds, kuromojiResults));
            const aiErrorPoints = errorPointCreator.createErrorPoint(new AIErrorPoints(gptResult.errors, lintText));
            //エラーポイントをマージ
            const mergedErrorPoints = errorPointCreator.mergeErrorPoints(aiErrorPoints, lintErrorPoints);
            console.log('mergedErrorPoints', mergedErrorPoints);
            //重複するエラーポイントを優先順位を考慮して削除
            const uniqueErrorPoints = errorPointCreator.removeDuplicateErrorPoints(mergedErrorPoints);
            console.log('uniqueErrorPoints', uniqueErrorPoints);
            const { finalErrorAnalysis, aiErrorPointsInfo, lintErrorPointsInfo } = errorPointCreator.createErrorPointsInfo(uniqueErrorPoints);
            //signale.abort()が呼ばれた場合は処理を中断
            if (signal.aborted) {
                return {
                    aiErrorPointsInfo: {},
                    lintErrorPointsInfo: {},
                    finalErrorAnalysis: {},
                    lintCounter: 0,
                    gptCounter: 0,
                };
            }
            // // 入力エリアのテキストをspanタグで装飾
            const decorater = new Decorater(this.text);
            this.targetContent.innerHTML = decorater.decorate(uniqueErrorPoints, this.text);
            console.log('finalErrorAnalysis', finalErrorAnalysis);
            console.log('lintErrorPointsInfo', lintErrorPointsInfo);
            console.log('aiErrorPointsInfo', aiErrorPointsInfo);
            return {
                aiErrorPointsInfo: aiErrorPointsInfo,
                lintErrorPointsInfo: lintErrorPointsInfo,
                finalErrorAnalysis: finalErrorAnalysis,
                lintCounter: Object.keys(lintErrorPointsInfo).length,
                gptCounter: Object.keys(aiErrorPointsInfo).length,
            };
        });
    }
}
